import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Base } from './Base.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
var StringT = /*#__PURE__*/function (_Base) {
  _inherits(StringT, _Base);
  var _super = _createSuper(StringT);
  function StringT(length) {
    var _this;
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascii';
    _classCallCheck(this, StringT);
    _this = _super.call(this);
    _this.length = length;
    _this.encoding = encoding;
    return _this;
  }
  _createClass(StringT, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length, pos;
      if (this.length != null) {
        length = utils.resolveLength(this.length, stream, parent);
      } else {
        var buffer;
        buffer = stream.buffer;
        length = stream.length;
        pos = stream.pos;
        while (pos < length && buffer[pos] !== 0x00) {
          ++pos;
        }
        length = pos - stream.pos;
      }
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent, parent) || 'ascii';
      }
      var string = stream.readString(length, encoding);
      if (this.length == null && stream.pos < stream.length) {
        stream.pos++;
      }
      return string;
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      // Use the defined value if no value was given
      if (!val) {
        return utils.resolveLength(this.length, null, parent);
      }
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
      }
      if (encoding === 'utf16be') {
        encoding = 'utf16le';
      }
      var size = byteLength(val, encoding);
      if (this.length instanceof NumberT) {
        size += this.length.size();
      }
      if (this.length == null) {
        size++;
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
      }
      if (this.length instanceof NumberT) {
        this.length.encode(stream, byteLength(val, encoding));
      }
      stream.writeString(val, encoding);
      if (this.length == null) {
        return stream.writeUInt8(0x00);
      }
    }
  }]);
  return StringT;
}(Base);
function byteLength(string, encoding) {
  switch (encoding) {
    case 'ascii':
      return string.length;
    case 'utf8':
      var len = 0;
      for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
          var c2 = string.charCodeAt(++i);
          if ((c2 & 0xfc00) === 0xdc00) {
            c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
          } else {
            // unmatched surrogate.
            i--;
          }
        }
        if ((c & 0xffffff80) === 0) {
          len++;
        } else if ((c & 0xfffff800) === 0) {
          len += 2;
        } else if ((c & 0xffff0000) === 0) {
          len += 3;
        } else if ((c & 0xffe00000) === 0) {
          len += 4;
        }
      }
      return len;
    case 'utf16le':
    case 'utf16-le':
    case 'utf16be':
    case 'utf16-be':
    case 'ucs2':
      return string.length * 2;
    default:
      throw new Error('Unknown encoding ' + encoding);
  }
}
export { StringT as String };